import "../css/CRMCampaignStatsMetric.css";

export function CRMCampaignStatsMetric({ label, value }) {
  return (
    <div className="crm-stats-metric">
      <span className="crm-stats-metric__label">{label}</span>
      <span className="crm-stats-metric__value">{value}</span>
    </div>
  );
}
